var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 0a15 15 0 110 30 15 15 0 010-30zm2 16h-4c-3 0-5.5 2.2-5.5 5 0 .6.5 1 1 1h13c.5 0 1-.4 1-1 0-2.8-2.4-5-5.4-5zM15 6a4.5 4.5 0 000 9 4.5 4.5 0 000-9z"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle--account-6e912413481153a3c5fe0d1417813ac5.svg";
export { SvgIconCircleAccount as Component };